export const operatorToPartnerTagMapping = {
  // Manage Operator Accounts -> Manage Partner Accounts
  rolesAndTemplates: "rolesAndTemplates",
  operatorAccounts: "partnerAccounts",

  // Lockers (same for both)
  lockers: "lockers",
  lockerFees: "lockerFees",
  lockerStorageFees: "lockerStorageFees",
  assignToBranch: "assignToBranch",
  assignToAgent: "assignToAgent",
  lockerCleanUp: "lockerCleanUp",

  // Locker Users (same for both)
  lockerUserAccounts: "lockerUserAccounts",
  lockerUserType: "lockerUserType",
  viewPackageHistory: "viewPackageHistory",
  broadcastUser: "broadcastUser",

  // Agents (same for both)
  agents: "agents",
  batchUpload: "batchUpload",
  broadcastAgents: "broadcastAgents",

  // Partners -> Sub-Partners (same for both)
  partners: "partners",
  partnerTypes: "partnerTypes",
  branches: "branches",
  paymentModeAndFees: "paymentModeAndFees",

  // Settings (same for both)
  lockerTimeLimits: "lockerTimeLimits",
  storageTimeLimits: "storageTimeLimits",
  lockerUserTemplates: "lockerUserTemplates",
  courierTemplates: "courierTemplates",
  lockerCleanupTemplates: "lockerCleanupTemplates",
  walletTopUp: "walletTopUp",

  // Campaigns (same for both)
  behavioralCampaign: "behavioralCampaign",

  // Reports (same for both)
  dropoffStatusHistory: "dropoffStatusHistory",
  lockerOccupancy: "lockerOccupancy",
  lockerFullAlerts: "lockerFullAlerts",
  lockerOccupancyPeakHoursReport: "lockerOccupancyPeakHoursReport",
  packageDropoffPeakHoursReport: "packageDropoffPeakHoursReport",
  staytimeInLocker: "staytimeInLocker",
  partnerPerformance: "partnerBranchPerformance",
  podReports: "podReports",
  podSummaryReport: "podSummaryReport",
  storageRentals: "storageRentals",
  storageFeesSummaryReport: "storageFeesSummaryReport",
  overstayFees: "overstayFees",
  overstayFeesReportSummary: "overstayFeesReportSummary",

  // Operations Report (same for both)
  suspiciousCourierOPReport: "suspiciousCourierOPReport",
  highRemovalCouriers: "highRemovalCouriers",
  suspiciousCourierTagging: "suspiciousCourierTagging",
  unrecognizedWaybillOPReport: "unrecognizedWaybillOPReport",
  decliningUsageReport: "decliningUsageReport",
  lockerClearingSummary: "lockerClearingSummary",

  // Accounting (same for both)
  collectionSummary: "collectionSummary",
  refundRequests: "refundRequests",
};

export const alwaysVisiblePartnerPages = {
  // These pages will ALWAYS show in the permission dialog
  // regardless of operator's permissions
  partnerRolesAndTemplates: {
    displayName: "Roles and Templates",
    group: "manage-partner-accounts", // Changed from manage-operator-accounts
    defaultPermission: null,
    isLocked: false, // Operator CAN control this
    // mappedFrom: "rolesAndTemplates", // Track which operator page this maps to
  },
  partnerAccounts: {
    displayName: "Partner Accounts",
    group: "manage-partner-accounts",
    defaultPermission: null,
    isLocked: false,
    // mappedFrom: "operatorAccounts",
  },
  partnerDashboard: {
    displayName: "Partner Dashboard",
    group: "general",
    defaultPermission: "2", // Auto-granted to all partners
    isLocked: true, // Cannot be changed by operator
  },
  partnerProfile: {
    displayName: "Partner Profile",
    group: "profile-settings",
    defaultPermission: "2",
    isLocked: true,
  },
  partnerBilling: {
    displayName: "Partner Collection Report",
    group: "reports",
    defaultPermission: null,
    isLocked: false,
  },
  partnerNotifications: {
    displayName: "Notification Settings",
    group: "settings",
    defaultPermission: "1",
    isLocked: true,
  },
};

// ⭐ DEFINE GROUP ORDER (accordion sections)
export const groupDisplayOrder = [
  "general", // Partner Dashboard (at the top)
  "manage-partner-accounts", // Roles, Partner Accounts
  "profile-settings", // Partner Profile
  "lockers",
  "locker-users",
  "agents",
  "partners",
  "settings",
  "campaigns",
  "reports",
  "operations-report",
  "accounting",
];

// ⭐ DEFINE PAGE ORDER WITHIN EACH GROUP
export const pageDisplayOrder = {
  general: ["partnerDashboard"],
  "manage-partner-accounts": ["partnerRolesAndTemplates", "partnerAccounts"],
  "profile-settings": ["partnerProfile"],
  lockers: [
    "lockers",
    "lockerFees",
    "lockerStorageFees",
    "assignToBranch",
    "assignToAgent",
    "lockerCleanUp",
  ],
  "locker-users": [
    "lockerUserAccounts",
    "lockerUserType",
    "viewPackageHistory",
    "broadcastUser",
  ],
  agents: ["agents", "batchUpload", "broadcastAgents"],
  partners: ["partners", "partnerTypes", "branches", "paymentModeAndFees"],
  settings: [
    "lockerTimeLimits",
    "storageTimeLimits",
    "lockerUserTemplates",
    "courierTemplates",
    "lockerCleanupTemplates",
    "walletTopUp",
    "partnerNotifications", // Partner-only page in settings
  ],
  campaigns: ["behavioralCampaign"],
  reports: [
    "dropoffStatusHistory",
    "lockerOccupancy",
    "lockerFullAlerts",
    "lockerOccupancyPeakHoursReport",
    "packageDropoffPeakHoursReport",
    "staytimeInLocker",
    "partnerBranchPerformance",
    "podReports",
    "podSummaryReport",
    "storageRentals",
    "storageFeesSummaryReport",
    "overstayFees",
    "overstayFeesReportSummary",
    "partnerBilling", // Partner-only page at the end
  ],
  "operations-report": [
    "suspiciousCourierOPReport",
    "highRemovalCouriers",
    "suspiciousCourierTagging",
    "unrecognizedWaybillOPReport",
    "decliningUsageReport",
    "lockerClearingSummary",
  ],
  accounting: ["collectionSummary", "refundRequests"],
};

// Helper function to sort groups
export const sortGroupsByOrder = (groups) => {
  return groups.sort((a, b) => {
    const indexA = groupDisplayOrder.indexOf(a.value);
    const indexB = groupDisplayOrder.indexOf(b.value);

    // If not in order list, put at end
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
};

// Helper function to sort pages within a group
export const sortPagesByOrder = (pages, groupName) => {
  const order = pageDisplayOrder[groupName] || [];

  return pages.sort((a, b) => {
    // Handle array values (like reports with multiple tags)
    const valueA = Array.isArray(a.value) ? a.value[0] : a.value;
    const valueB = Array.isArray(b.value) ? b.value[0] : b.value;

    const indexA = order.indexOf(valueA);
    const indexB = order.indexOf(valueB);

    // If not in order list, maintain original order
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
};
